const DENIED_WORKSPACES_KEY = "denied_workspaces"
const DENIED_WORKSPACES_TTL_MS = 60_000

type DeniedEntry = { id: string; t: number }

function readEntries(): DeniedEntry[] {
  try {
    const raw = sessionStorage.getItem(DENIED_WORKSPACES_KEY)
    if (raw == null) return []
    const parsed = JSON.parse(raw) as DeniedEntry[]
    const cutoff = Date.now() - DENIED_WORKSPACES_TTL_MS
    return parsed.filter((e) => e.t >= cutoff)
  } catch {
    return []
  }
}

export function getDeniedWorkspaceIds(): string[] {
  return readEntries().map((e) => e.id)
}

export function addDeniedWorkspaceId(id: string): void {
  try {
    const fresh = readEntries()
    if (!fresh.some((e) => e.id === id)) {
      fresh.push({ id, t: Date.now() })
    }
    sessionStorage.setItem(DENIED_WORKSPACES_KEY, JSON.stringify(fresh))
  } catch {
    // sessionStorage may be unavailable (e.g. private browsing)
  }
}
